import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";

export default function Legal({ type }) {
  const navigate = useNavigate();
  const { t } = useI18n();
  const title = t(`legal.${type}.title`);
  const blocks = t(`legal.${type}.blocks`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <div data-testid={`legal-page-${type}`} className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-24">
        <button
          data-testid="legal-back-btn"
          onClick={() => navigate("/")}
          className="mb-12 inline-flex items-center gap-2 text-sm font-light text-[#4a4a4a] transition-colors hover:text-[#050505]"
        >
          <ArrowLeft size={16} /> {t("legal.back")}
        </button>

        <h1 className="font-display text-4xl font-light tracking-tightest text-[#050505] md:text-6xl">
          {title}
        </h1>
        <p className="mt-4 text-sm font-light text-[#9a9a9a]">{t("legal.updated")}</p>

        <div className="mt-14 space-y-10">
          {blocks.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-display text-xl font-normal text-[#050505] md:text-2xl">{h}</h2>
              <p className="mt-3 text-base font-light leading-relaxed text-[#4a4a4a]">{p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
